//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { RightsOwnedOrPendingModalAction } from '@galleries/actions/rightsOwnedOrPendingModalActions';
import { RIGHTS_OWNED_OR_PENDING_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IRightsOwnedOrPendingModalState } from '@galleries/models/rightsOwnedOrPendingModalModel';

export const initialState: IRightsOwnedOrPendingModalState = {
  isOpen: false,
  rightsOwnedItems: [],
  numTotalItems: undefined,
};

export default function RightsOwnedOrPendingModalReducer(
  state: IRightsOwnedOrPendingModalState = initialState,
  action: RightsOwnedOrPendingModalAction,
): IRightsOwnedOrPendingModalState {
  switch (action.type) {
    case RIGHTS_OWNED_OR_PENDING_MODAL_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
        numTotalItems: action.numTotalItems,
        rightsOwnedItems: action.rightsOwnedItems,
      };
    case RIGHTS_OWNED_OR_PENDING_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}
